import { Component } from "@angular/core";

@Component({
	selector: "financial-reconciliation-warning",
	templateUrl: "./financial-reconciliation-warning.html",
	styleUrls: ["./financial-reconciliation-warning.scss"],
})
export class LoadFinancialReconciliationWarningComponent {
}
